import React, { useEffect } from 'react';

import Box from 'components/Box';
import NotFoundContent from 'components/NotFoundContent';
import Layout from 'layouts/Layout';
import { gutterWidth, maxWidth } from 'theme';
import { setDocumentTitle } from 'utils/meta';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const NotFoundPage = ({
  searchText,
  searchUrl,
}: {
  searchText?: string;
  searchUrl?: string;
}) => {
  useEffect(() => {
    /* TRANSLATORS: 404 page title */
    setDocumentTitle(getText('Page Not Found'));
  }, []);
  return (
    <Layout>
      <Box
        mx="auto"
        maxWidth={[480, null, maxWidth[3]]}
        p={[gutterWidth / 2, null, null, gutterWidth]}
      >
        <NotFoundContent searchText={searchText} searchUrl={searchUrl} />
      </Box>
    </Layout>
  );
};

export default NotFoundPage;
